module.exports = __webpack_public_path__ + "40bd8fdfd188ac1e42c8ab4013630cbf.jpg";